import { FC } from 'react';
import { Badge, Text } from '../../../shared/uiComponents';
import { InsuranceDetailProperties } from '../../../redux/API/ClientAPIHelpers/insuranceProperties';

interface TelehealthCardProps {
	insurance: InsuranceDetailProperties;
}

const TelehealthCard: FC<TelehealthCardProps> = ({ insurance }) => (
	<div className="insuranceDetailCard">
		<Text title="Telehealth Settings" type="h6" fontWeight="semiBold" />
		<div style={{ marginTop: '20px' }}>
			<div className="insuranceDetailInfoRow">
				<Text title="Telehealth for Assessment:" type="psm" fontWeight="semiBold" />
				<Badge
					label={insurance.allowTelehealthForAssessment ? 'Yes' : 'No'}
					type={insurance.allowTelehealthForAssessment ? 'success' : 'gray'}
					sizeType="sm"
				/>
			</div>

			<div className="insuranceDetailInfoRow">
				<Text title="Telehealth for BTM:" type="psm" fontWeight="semiBold" />
				<Badge
					label={insurance.allowTelehealthForBTM ? 'Yes' : 'No'}
					type={insurance.allowTelehealthForBTM ? 'success' : 'gray'}
					sizeType="sm"
				/>
			</div>
		</div>
	</div>
);

export default TelehealthCard;
